import script from "./CheckPointQualityForm.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckPointQualityForm.vue?vue&type=script&setup=true&lang=js"

import "./CheckPointQualityForm.vue?vue&type=style&index=0&id=dd895348&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd895348"]])

export default __exports__